module.exports = __webpack_public_path__ + "img/calendar.3c82c988.svg";